import Index from './Loads'
import IndexHeading from './IndexHeading'
import Show from './Show'
import ShowHeading from './ShowHeading'
import Requests from './Requests'
import RequestsHeading from './RequestsHeading'
import LoadChecksHeading from './LoadChecksHeading'
import LoadChecksList from './LoadChecksList'

export default {
  Index,
  IndexHeading,
  Show,
  ShowHeading,
  Requests,
  RequestsHeading,
  LoadChecksHeading,
  LoadChecksList
}



// WEBPACK FOOTER //
// ./src/components/loads/index.js